export default {
    patentEditor: {
    // DraftingHeader component
        draftingHeader: {
            back: 'Back',
            backToProject: 'Back to home',
            editProjectName: 'Edit project name',
            folderUncategorized: 'Uncategorized',
            switchFolder: 'Switch folder',
            moveProjectConfirmTitle: 'Move project',
            moveProjectConfirmMessage: 'Move the current project to the selected folder?',
            moveProjectConfirmOk: 'Move',
            moveProjectConfirmCancel: 'Cancel',
            moveProjectSuccess: 'Project moved',
            moveProjectFailed: 'Failed to move project',
            switchProject: 'Switch project',
            recentProjects: 'Recent projects',
            noRecentProjects: 'No recent projects',
            browseAllProjects: 'Browse all projects',
            updateProjectNameSuccess: 'Project name updated successfully',
            updateProjectNameFailed: 'Failed to update project name',
            defaultTitle: 'Untitled Document',
            editTitle: 'Click to edit title',
            clickToEditName: 'Click to edit',
            screen: {
                single: 'Single Screen',
                split: 'Split Screen',
            },
            aiHiro: 'Hiro',
            save: 'Save',
            saveOptions: 'Save Options',
            saveToFolder: 'Save to Folder',
            saveSuccess: 'Saved successfully',
            saveFailed: 'Save failed',
            export: 'Export',
            exportAll: 'Export All',
            exportSuccess: 'Export successful',
            exportFailed: 'Export failed',
            settings: 'Settings',
            share: 'Share',
            sharePermissionDenied: 'Only the project owner can share',
            readOnlyWarning: 'permission: You have read-only access',
            emptyContentError: 'Content is empty, cannot save',
            updateTitleSuccess: 'Title updated successfully',
            updateTitleFailed: 'Failed to update title',
            importing: 'Importing document...',
            importSuccess: 'Import successful',
            importFailed: 'Import failed',
            exportUpgradeTip: 'Export is available on paid plans. ',
            upgradeLink: 'Upgrade now',
        },
        userPreferences: {
            title: 'Settings',
            taskDisclosure: 'Disclosure',
            taskPatentDraft: 'Patent Application',
            taskProsecution: 'Office Action Response',
            personalization: 'Personalization',
            description: 'Save persistent Markdown rules to guide future {taskType} tasks.',
            placeholder: 'Enter your execution rules here, for example:\n\n# Workflow\n\n- Analyze the request before proposing a solution\n- Check facts and formatting before responding',
            saving: 'Saving...',
            saveSuccess: 'Settings saved',
            saveFailed: 'Failed to save settings',
            loadFailed: 'Failed to load settings',
            closeConfirmTitle: 'Discard changes',
            closeConfirmMessage: 'Your settings have unsaved changes. Close anyway?',
            switchConfirmMessage: 'Your settings have unsaved changes. Switch task type and discard them?',
            closeConfirmOk: 'Discard',
        },
        // AddSourceDialog specific i18n
        addSource: {
            title: 'Add Source',
            createDocument: 'Create Document',
            selectDocumentType: 'Select document type and create',
        },
        // Blank document feature (patent-editor specific)
        blank: {
            tab: 'Blank',
            placeholder: 'Create a blank document',
            title: 'Blank Document',
            description: 'Create an empty document and start writing from scratch',
            action: 'Create Blank Document',
        },
        // SourceTabs component
        sourceTabs: {
            closeOthers: 'Close Others',
            closeAll: 'Close All',
            files: 'Files',
            originalText: 'Original Text',
        },
    },
};
